import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChairIcon(props: IconProps) {
    return <Icon {...props} iconKey={"chair"}/>
}
